export default __webpack_public_path__ + "static/step-1-ffef49783fb1e7bf93af47585a1925eb.png";